module.exports = __webpack_public_path__ + "img/clientes_3.3349d11d.png";